<script lang="ts">
    import { ActiveColorStore } from "../store/ColorStores";
    import { ColorListStore } from "../store/ColorStores";
</script>

{#if $ColorListStore.length > 0}
    <div class="active-color-container">
        <span>
            R: <input
                type="number"
                bind:value={$ActiveColorStore.r}
                on:change={() => ColorListStore.update($ActiveColorStore)}
                min="0"
                max="255"
            />
        </span>
        <span>
            G: <input
                type="number"
                bind:value={$ActiveColorStore.g}
                on:change={() => ColorListStore.update($ActiveColorStore)}
                min="0"
                max="255"
            />
        </span>
        <span>
            B: <input
                type="number"
                bind:value={$ActiveColorStore.b}
                on:change={() => ColorListStore.update($ActiveColorStore)}
                min="0"
                max="255"
            />
        </span>
    </div>
{/if}

<div class="color-preview-container">
    {#each $ColorListStore as color}
        <div
            class="color-preview"
            on:click={() => ActiveColorStore.set(color)}
            style="background-color: rgba({color.r}, {color.g}, {color.b}, {color.a})"
        >
            {#if $ActiveColorStore.uuid === color.uuid}
                <div
                    class="delete"
                    on:click={() => ColorListStore.delete(color)}
                >
                    x
                </div>
            {/if}
        </div>
    {/each}

    <span
        class="color-preview"
        on:click={() => {
            ColorListStore.add();
            ActiveColorStore.set($ColorListStore[$ColorListStore.length - 1]);
        }}>+</span
    >
</div>

<style>
    .color-preview-container {
        display: flex;
    }
    .color-preview {
        position: relative;
        border: 1px solid black;
        margin-left: 5px;
        width: 30px;
        height: 30px;
        text-align: center;
    }

    .delete:hover {
        cursor: pointer;
    }
    .delete {
        background-color: white;
        border-radius: 25px;
        border: 1px solid red;
        width: 15px;
        height: 15px;
        line-height: 15px;
        text-align: center;
        color: red;
        position: absolute;
        top: -7px;
        right: -7px;
    }
</style>
